const { getDynatraceConfig } = require('./util');

/**
 * Initialize Dynatrace RUM (Real User Monitoring)
 * Loads the Dynatrace script dynamically if configuration is available
 */
export function initializeDynatraceRum() {
  // Check if script is already loaded (might have been injected by SSR)
  if (document.getElementById('dynatrace-rum-script')) {
    return;
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      loadDynatraceScript();
    });
  } else {
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(() => {
      loadDynatraceScript();
    }, 0);
  }
}

function loadDynatraceScript() {
  const dynatraceConfig = getDynatraceConfig();

  if (!dynatraceConfig) {
    return;
  }

  // Check if script is already loaded
  if (document.getElementById('dynatrace-rum-script')) {
    return;
  }

  // Construct the Dynatrace script URL
  const scriptUrl = `https://js-cdn.dynatrace.com/jstag/${dynatraceConfig}_complete.js`;

  // Create and append the script tag
  const script = document.createElement('script');
  script.id = 'dynatrace-rum-script';
  script.type = 'text/javascript';
  script.src = scriptUrl;
  script.crossOrigin = 'anonymous';
  script.defer = true;

  script.onerror = (error) => {
    console.error('Dynatrace RUM: Failed to load script:', error);
  };

  // Append to head for early loading
  document.head.appendChild(script);
}

